import React from 'react';
import { Box, Skeleton, Grid } from '@mui/material';

const OverviewSkeleton: React.FC = () => {
  return (
    <Box sx={{ py: 2 }}>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
        <Skeleton variant="circular" width={40} height={40} />
      </Box>

      <Grid container spacing={3}>
        {/* Account Status Card Skeleton */}
        <Grid item xs={12} md={6}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
              <Skeleton variant="text" width="40%" height={24} />
            </Box>
            <Grid container spacing={2}>
              {[1, 2, 3].map(item => (
                <Grid item xs={4} key={item}>
                  <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
              ))}
            </Grid>
            <Skeleton
              variant="rectangular"
              width="30%"
              height={32}
              sx={{ mt: 2, borderRadius: 1 }}
            />
          </Box>
        </Grid>

        {/* Usage Summary Card Skeleton */}
        <Grid item xs={12} md={6}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
              <Skeleton variant="circular" width={24} height={24} sx={{ mr: 1 }} />
              <Skeleton variant="text" width="40%" height={24} />
            </Box>
            <Grid container spacing={2}>
              {[1, 2, 3].map(item => (
                <Grid item xs={4} key={item}>
                  <Skeleton variant="text" width="80%" height={32} sx={{ mb: 1 }} />
                  <Skeleton variant="text" width="60%" height={20} />
                </Grid>
              ))}
            </Grid>
            <Skeleton
              variant="rectangular"
              width="30%"
              height={32}
              sx={{ mt: 2, borderRadius: 1 }}
            />
          </Box>
        </Grid>

        {/* API Key Card Skeleton */}
        <Grid item xs={12}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={56}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Skeleton variant="rectangular" width="80px" height={32} sx={{ borderRadius: 1 }} />
              <Skeleton variant="rectangular" width="100px" height={32} sx={{ borderRadius: 1 }} />
            </Box>
          </Box>
        </Grid>

        {/* Code Example Card Skeleton */}
        <Grid item xs={12}>
          <Box sx={{ p: 3, border: '1px solid #e0e0e0', borderRadius: 2 }}>
            <Skeleton variant="text" width="40%" height={24} sx={{ mb: 2 }} />
            <Skeleton
              variant="rectangular"
              width="100%"
              height={120}
              sx={{ mb: 2, borderRadius: 1 }}
            />
            <Skeleton variant="text" width="60%" height={20} />
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default OverviewSkeleton;
